<template>
  <sl-side-panel v-model="modalVisible" :mask-closable="false" :title="itemTitle">
    <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="110">
      <FormItem label="申请企业：" prop="companyId">
        <sl-select :data="companies" v-model="form.companyId" @on-change="queryDefault" :filterable="true" />
      </FormItem>
      <FormItem label="申请数量：" prop="applyCount">
        <InputNumber :min="1" :step="1" v-model="form.applyCount"></InputNumber>
      </FormItem>
      <FormItem label="联系人：" prop="connectName">
        <Input v-model="form.connectName" :maxlength="64"></Input>
      </FormItem>
      <FormItem label="联系电话：" prop="connectPhone">
        <Input v-model="form.connectPhone"></Input>
      </FormItem>
      <FormItem label="所属区域：" prop="geo">
        <!-- <sl-area v-model="geoArray" @on-change="areaChange"></sl-area> -->
        <span>{{geoObj.geoText}}</span>
      </FormItem>
      <FormItem label="经营地址：" prop="address">
        <!-- <Input v-model="form.address" :maxlength="64" readonly></Input> -->
        <span>{{geoObj.businessAddress}}</span>
      </FormItem>
      <FormItem label="纸质申请单：" prop="imgPath">
        <sl-upload v-model="form.imgPath" type="17"></sl-upload>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
    </div>
  </sl-side-panel>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      rules: {
        companyId: [
          { required: true, type: 'number', required: true, message: '请选择企业', trigger: 'blur,change' },
        ],
        applyCount: [{
          required: true,
          pattern: /^[1-9]\d*$/,
          message: '请输入申请数量',
          trigger: 'blur,change',
        }, ],
        connectName: [
          { required: true, required: true, message: '请输入联系人', trigger: 'blur,change' },
        ],
        connectPhone: [
          { required: true, validator: this.validatorConnectPhone, message: '请输入联系电话', trigger: 'blur,change' },
        ],
        imgPath: [
          { required: true, message: '请上传纸质申请单', trigger: 'blur,change' }
        ],
      },
      def: {},
      form: {
        id: null,
        companyId: null,
        applyCount: null,
        connectName: null,
        connectPhone: null,
        imgPath: null
      },
      id: null,
      loading: false,
      isCreate: true,
      companies: [],
      modalVisible: false,
      geoArray: null,
      companyObj: {},
      geoObj: {},
    }
  },

  computed: {
    itemTitle() {
      return '车牌申请'
    }
  },
  created() {
    this.def = { ...this.form }
    this.$request.companies({ pageSize: 99999, search: {} }).then(resp => {
      this.companies = resp.data.list.map(i => ({
        value: i.id,
        label: i.companyName
      }))
    })
  },

  methods: {
    validatorConnectPhone(rule, value, callback) {

      let reg1 = /^(\+\d{2}-)?0\d{2,3}-\d{7,8}$/
      let reg2 = /^(\+\d{2}-)?(\d{2,3}-)?(1[2-9][0-9]\d{8})$/
      if (value && (reg1.test(value) || reg2.test(value))) {
        callback()
      } else {
        callback(new Error('请输入联系电话'))
      }
    },

    init(id) {
      this.id = id
      this.reset()
      this.modalVisible = true
    },

    queryDefault(id) {
      this.form.connectName = ''
      this.form.connectPhone = ''
      this.geoObj = {}
      if (!id) {
        return
      }
      this.$request.carLicenseApplyInfoChoice(id).then(resp => {
        this.form.connectName = resp.data.legalName || ''
        this.form.connectPhone = resp.data.legalPhone || ''
        this.companyObj = resp.data || {}
        this.geoObj.businessAddress = this.companyObj.businessAddress || ''
        this.getGeoText()
      })

    },
    getGeoText() {
      let obj = this.companyObj
      let txt = ''
      if (obj.province && obj.city && (obj.province === obj.city)) {
        txt = obj.city + obj.area
      } else {
        txt = obj.province + obj.city + obj.area
      }
      this.geoObj.geoText = txt
    },

    reset() {
      this.geoObj = {}
      this.$utils.fill(this.form, this.def)
      this.$refs['form'].resetFields()
    },

    save() {

      let params = JSON.parse(JSON.stringify(this.form))

      params.province = this.companyObj.province || ''
      params.city = this.companyObj.city || ''
      params.area = this.companyObj.area || ''

      params.address = this.companyObj.businessAddress || ''

      delete params.id

      this.loading = true
      let promise = this.$request.carLicenseApplyInfoPost
      promise(params).then(resp => {
        if (resp.code) {
          this.$Message.error({ content: resp.msg })
        } else {
          this.$Message.success('保存成功')
          this.$emit('on-update')
          if (!this.id) {
            this.modalVisible = false
          }
        }
        this.loading = false
      })

    },

    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误');
        }
      })
    },
    handleClose() {
      this.$emit('on-update')
    },

    areaChange(arr) {
      this.form.geo = JSON.parse(JSON.stringify(arr))
      console.log('areaChange-----', arr)
    }
  }
}

</script>
